// extracted by mini-css-extract-plugin
export default {"main":"Aboutme_main__uO2mV","row":"Aboutme_row__ClhNZ","about":"Aboutme_about__ZXhSX","logo":"Aboutme_logo__PebAd","aboutvision":"Aboutme_aboutvision__hwUmX"};